import { Column } from "../decorators/column";
import { autoserializeAs } from "cerializr";

export class NoScreenedAccScreeningMethodReport {
    @autoserializeAs(String)
    @Column({
        columnName: 'Screening Method'
    })
    screeningMethod: string;
    @autoserializeAs(String)
    @Column({
        columnName: 'Count'
    })
    count: string;
    @autoserializeAs(String)
    @Column({
        columnName: 'Percent'
    })
    percent: string;
}
